<template>
  <div
    class="border-t md:border-t-0 md:border-l-3 md:col-span-5 pt-30 md:pl-30 md:py-40 xl:pl-60 xl:py-60"
  >
    <h1 v-if="title" class="is-1">
      {{ title }}
    </h1>

    <div v-if="lead" class="is-4 mt-30 lg:mt-50" v-html="lead" />

    <div v-if="points" class="product-points mt-30 lg:mt-50" v-html="points" />

    <ProductVariationSelector
      v-if="variation"
      :variations="variations"
      :active-sku="variation.sku"
    >
      <ProductSizeguide v-if="sizeguide" :sizeguide="sizeguide" />
    </ProductVariationSelector>

    <div v-if="variation" class="mt-25 lg:mt-50mt-25 lg:mt-50">
      <ProductPrice :prices="variation.prices" class="is-small font-bold" />

      <div class="is-small mt-5">{{ variation.label }}</div>

      <div v-if="variation.sku" class="is-small mt-5">
        {{ $texts('product.skuPrefixText') }} {{ variation.sku }}
      </div>

      <div v-if="delivery" class="is-small mt-5">
        {{ $texts('product.deliveryText') }}:
        {{ delivery }}
      </div>

      <div class="mt-25 lg:mt-40 flex gap-15 items-center">
        <ProductShopifyLink
          :links="variation.shopifyLinks"
          @click="$emit('clickShopify')"
        />
        <ProductStoreLocator v-if="variation.sku" :sku="variation.sku" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type {
  ProductSizeguideEntityFragment,
  ProductVariationFragment,
} from '#build/graphql-operations'

defineProps<{
  title?: string
  lead?: string
  points?: string
  delivery?: string
  sizeguide?: ProductSizeguideEntityFragment
  variations: ProductVariationFragment[]
  variation?: ProductVariationFragment
}>()

defineEmits<{
  (e: 'clickShopify'): void
}>()
</script>

<style lang="postcss">
.product-points {
  @apply grid gap-25;

  ul {
    @apply pl-0 grid gap-25;
  }

  p,
  ul li {
    @apply list-none flex text-lg lg:text-2xl font-light tracking-normal;
    &:before {
      @apply pr-10;

      content: url('~/assets/symbols/bullet_mobile.svg');
      @screen md {
        content: url('~/assets/symbols/bullet.svg');
      }
    }
  }
}
</style>
